import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, timeout: 15000 });

export const decodeVin = (vin) => api.get(`/vin/${vin}`).then((r) => r.data);
export const submitLead = (payload) => api.post(`/leads`, payload).then((r) => r.data);
export const fetchEstimate = (leadId) => api.get(`/leads/${leadId}/estimate`).then((r) => r.data);
export const submitContact = (payload) => api.post(`/contact`, payload).then((r) => r.data);
export const uploadOffer = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/uploads/offer`, fd, { timeout: 120000 }).then((r) => r.data);
};

// ---- Owner-only (admin key is typed once on the owner's device; never shipped in code) ----
const adminHeaders = (key) => ({ headers: { "X-Admin-Key": key } });
export const adminPing = (key) => api.get(`/admin/ping`, adminHeaders(key)).then((r) => r.data);
export const fetchLeadsAdmin = (key, limit = 200) => api.get(`/leads`, { params: { limit }, ...adminHeaders(key) }).then((r) => r.data);
export const updateLeadStatus = (key, id, status, owner_notes) =>
  api.patch(`/leads/${id}/status`, { status, owner_notes }, adminHeaders(key)).then((r) => r.data);
